import { MutationTree } from 'vuex';
import { CircularPianoState } from '@/store/types/circular-piano.state';

export const mutations: MutationTree<CircularPianoState> = {
    setSelectedNote(state, value) {
        state.selectedNote = value;
    },
    setPreviousNote(state, value) {
        state.previousNote = value;
    },
    setColors(state, value) {
        state.colors = value;
    },
    setRelationArray(state, value) {
        state.relationArray = value;
    },
    setShowChromatics(state, value) {
        state.showChromatics = value;
    },
    setDesc(state, value) {
        state.desc = value;
    },
    setStarted(state, value) {
        state.started = value;
    },
    setHueSlider(state, value) {
        state.hueSlider = value;
    },
};
